import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

// components
import FollowUs from '../vue/components/common/FollowUs.vue';
import ChoosePlanSchool from '../vue/template-school/ChoosePlanSchool.vue';

export default {
    init () {
        const vueChoosePlanSchool = document.getElementById('vue-choose-plan-school');

        new Vue({
            data: {
            },
            render (createElement) {
                const headerInformation = {
                    title: vueChoosePlanSchool.dataset.choosePlanSchoolTitle,
                    subtitle: vueChoosePlanSchool.dataset.choosePlanSchoolSubtitle,
                    tooltip: vueChoosePlanSchool.dataset.choosePlanSchoolTooltip,
                    membershipGroupSelectorActive: vueChoosePlanSchool.dataset.choosePlanSchoolMembershipGroupSelectorActive,
                };

                const options = {
                    props: {
                        headerInformation: headerInformation,
                        groupOne: JSON.parse(vueChoosePlanSchool.dataset.groupOne),
                        groupTwo: JSON.parse(vueChoosePlanSchool.dataset.groupTwo),
                        groupThree: JSON.parse(vueChoosePlanSchool.dataset.groupThree),
                    },
                };

                return createElement(ChoosePlanSchool, options);
            },
            created () {
            },
        }).$mount('#vue-choose-plan-school');

        new Vue({
            render (createElement) {
                return createElement(FollowUs);
            },
        }).$mount('#vue-follow-us');
    },
    finalize () {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSchool.js